import { Card } from "antd";
import { TrendingUp } from "lucide-react";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import PerformanceHeader from "./PerformanceHeader";


const PerformanceScoreSummary = ( props ) => {
  const {} = props;

  const performanceBreakdown = [
  {   
    id: 1,
    category: "Our People",
    percentage: 87.5,
  },
    {   
    id: 2,
    category: "Our Service",
    percentage: 93.75,
  },
  {   
    id: 3,
    category: "Our Growth",
    percentage: 87.5,
  },


]
  
  	return (
      <PerformanceHeader
          title="Performance Score"
          description="Latest review from Q3 2025"
					icon={<TrendingUp size={20}/>}
          cardTheme="white-emerald"
          rightNav="Q3 2025"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <div className="flex items-baseline gap-2">
              <p className="card-text text-[48px] font-bold">92</p>
              <span>/100</span>
            </div>
            <p className="card-text text-[14px] font-semibold">Exceeds Expectations</p>
            <p className="text-[11px]">Review Date: 2025-09-15</p>
          </div>
          <div>
            <h4 className="text-[12px] font-semibold">
              Category Breakdown
            </h4>
            {performanceBreakdown.map((item) => (
              <div key={item.id} className="mt-2">
                <div className="flex items-center justify-between p-2 rounded-xl bg-white border border-emerald-100">
                  <p className="text-[11px]">{item.category}</p>
                  <span className="text-[13px] font-semibold card-text">{item.percentage}%</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </PerformanceHeader>
				
                
                  


);
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(PerformanceScoreSummary);
